import { ValidationHelper } from '@bimser/core';
import IconActualSize from '@bimser/icons/16/actual-size';
import IconCollapse from '@bimser/icons/16/collapse';
import IconExpand from '@bimser/icons/16/expand';
import IconFitToScreen from '@bimser/icons/16/fit-to-screen';
import _debounce from 'lodash/debounce';
import * as React from 'react';
import BCInputNumber from '../BCInputNumber';
import { findMessage } from '../BCIntl';
import BCLabel from '../BCLabel';
import BCSlider from '../BCSlider';
import BCTooltip from '../BCTooltip';
import Style from './assets/style.scss';
import { IProps } from './entities';

const totalCountLabelStyle: React.CSSProperties = { marginLeft: '10px' };

const DiagramStateViewer = (props: IProps) => {
	const onChangeSlider = (scale?: number) => {
		props.setZoomScale?.(scale);
	};

	const defaultScreen = () => {
		onChangeSlider(props.defaultZoomScale);
	};

	const onDblClick = (e: any) => {
		e.preventDefault();
		e.stopPropagation();
	};

	const decreaseZoomScale = () => {
		if (props.zoomScale - props.zoomScaleFactory >= props.minScale) {
			onChangeSlider(props.zoomScale - props.zoomScaleFactory);
		} else {
			onChangeSlider(props.minScale);
		}
	};

	const increaseZoomScale = () => {
		if (props.zoomScale + props.zoomScaleFactory <= props.maxScale) {
			onChangeSlider(props.zoomScale + props.zoomScaleFactory);
		} else {
			onChangeSlider(props.maxScale);
		}
	};

	const onChangeZoomInputNumber = _debounce((value?: number) => {
		if (ValidationHelper.Test(ValidationHelper.RegularExpressions.NumberDot, value, true)) {
			onChangeSlider(value);
		}
	}, 250);

	const scaleInputFormatter = (value?: React.ReactText) => `%${value}`;

	const scaleInputParser = (value: string) => value.replace('%', '');

	return (
		<div
			className={Style.diagramStateViewerContainer}
			onDoubleClick={onDblClick}
		>
			{!props.hideObjectCount && (
				<div className={Style.stateViewerContainer}>
					<BCLabel
						className={Style.label}
						customStyles={totalCountLabelStyle}
					>
						{findMessage.get('100997').replace('$1', String(props.elementCount))}{' '}
					</BCLabel>
				</div>
			)}
			<div className={Style.zoomPanelContainer}>
				<IconCollapse
					className={Style.changeScaleButtons}
					width="20px"
					onClick={decreaseZoomScale}
				/>
				<div className={Style.sliderContainer}>
					<BCSlider
						step={props.zoomScaleFactory}
						max={props.maxScale}
						min={props.minScale}
						defaultValue={props.zoomScale}
						value={props.zoomScale}
						onChange={onChangeSlider}
						tipFormatter={scaleInputFormatter}
					/>
				</div>
				<IconExpand
					className={Style.changeScaleButtons}
					width="20px"
					onClick={increaseZoomScale}
				/>
				<BCInputNumber
					className={Style.scaleInput}
					value={props.zoomScale}
					onChange={onChangeZoomInputNumber}
					precision={0}
					max={props.maxScale}
					min={props.minScale}
					formatter={scaleInputFormatter}
					parser={scaleInputParser}
				/>

				<BCTooltip
					title={findMessage.get('100888')}
					placement="top"
					trigger="hover"
					key="reset"
					mouseEnterDelay={1}
				>
					<div
						key="reset"
						className={Style.iconContainer}
					>
						<IconActualSize
							className={Style.icon}
							width="20px"
							style={{ marginLeft: '10px' }}
							onClick={defaultScreen}
						/>
					</div>
				</BCTooltip>
				{!props.hideFitScreen && (
					<BCTooltip
						title={findMessage.get('100999')}
						placement="top"
						trigger="hover"
						key="fitAllItem"
						mouseEnterDelay={1}
					>
						<div
							key="fitAllItem"
							className={Style.iconContainer}
						>
							<IconFitToScreen
								className={Style.icon}
								width="20px"
								style={{ marginLeft: '15px' }}
								onClick={props.setFitScreen}
							/>
						</div>
					</BCTooltip>
				)}
			</div>
		</div>
	);
};
export default DiagramStateViewer;
